<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>编辑常用回复</span>
      <span>
        <el-button
          type="primary"
          style="width: 92px"
          size="medium"
          @click="sumbit"
          >保存</el-button
        >
        <el-button
          plain
          style="width: 92px; color: #669961"
          size="medium"
          @click="back"
          >返回</el-button
        >
      </span>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <span>分组名称</span>
          <el-input
            v-model="name"
            style="width: 500px; margin-left: 10px"
            maxlength="5"
          ></el-input>
        </div>
        <div>
          <div style="padding-left: 66px; margin-top: 40px">
            <el-button
              plain
              icon="el-icon-circle-plus"
              size="medium"
              style="color: #669a60"
              @click="addReply"
              >新增回复内容</el-button
            >
          </div>
          <div style="margin: 10px 0 0 66px">
            <div class="item mytext" v-for="(ite, index) in list" :key="index">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="list[index]"
                class="reply"
                maxlength="100"
                show-word-limit
                autosize
              ></el-input>
              <div class="btn">
                <el-button
                  plain
                  icon="el-icon-delete"
                  circle
                  size="medium"
                  @click="delReply(index)"
                ></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import template from '../../../api/template';
export default {
  data() {
    return {
      name: '',
      list: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    getReply() {
      let type_id = this.$route.query.type_id;
      template
        .replyItem({ type_id })
        .then((res) => {
          if (res.code == 0) {
            this.name = res.data.info.type_name;
            this.list = res.data.info.reply_list;
            if (!this.list.length) {
              this.list[0] = '';
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //新增回复内容
    addReply() {
      if (this.list.length >= 10) {
        this.$message.error('回复内容最多支持10项');
        return false;
      }
      let aaa = '';
      this.list.push(aaa);
    },
    //删除回复内容
    delReply(index) {
      this.$confirm('确定删除回复内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.list.splice(index, 1);
        })
        .catch(() => {});
    },
    //保存
    sumbit() {
      let data = {
        type_id: this.$route.query.type_id,
        type_name: this.name,
        content: JSON.stringify(this.list)
      };
      template
        .editReply(data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.back();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getReply();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 30px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}

.item {
  display: flex;
  margin-bottom: 10px;
  box-sizing: border-box;

  .reply {
    width: 700px;
    margin-right: 22px;
    box-sizing: border-box;
  }
  .btn {
    display: flex;
    align-items: center;
  }
}
</style>
<style lang="scss">
.mytext .el-textarea__inner {
  padding: 10px 42px 10px 14px;
  resize: none;
}
</style>
